/*
 * Size chart drawer: the table header (title + column labels) and the current age group
 * row stay pinned while the chart scrolls, so it is always clear which chart and group a
 * row belongs to. The group row pins just under the header, whose height depends on the
 * table (one or two header rows) and the font, so it is measured rather than hard-coded.
 * Without this script the header still pins; the group rows just scroll normally.
 */
(() => {
  const setHeadHeight = (table) => {
    const head = table.tHead;
    if (!head) return;
    table.style.setProperty('--size-chart-head-height', `${head.offsetHeight}px`);
  };

  const observer = 'ResizeObserver' in window
    ? new ResizeObserver((entries) => {
        entries.forEach((entry) => setHeadHeight(entry.target.closest('table')));
      })
    : null;

  const init = (root = document) => {
    root.querySelectorAll('.js-size-chart__table').forEach((table) => {
      if (table.dataset.sizeChartReady) return;
      table.dataset.sizeChartReady = 'true';
      setHeadHeight(table);
      // the drawer starts hidden (height 0) and tables in the other tab too
      if (observer && table.tHead) observer.observe(table.tHead);
    });
  };

  // Larger text is a per-device preference, so remember it across drawers and visits
  const ZOOM_KEY = 'jackson-size-chart-large';
  const readZoom = () => {
    try {
      return window.localStorage.getItem(ZOOM_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const initZoom = (root = document) => {
    root.querySelectorAll('[data-size-chart-zoom]').forEach((input) => {
      if (input.dataset.sizeChartZoomReady) return;
      input.dataset.sizeChartZoomReady = 'true';
      input.checked = readZoom();
      input.addEventListener('change', () => {
        try {
          window.localStorage.setItem(ZOOM_KEY, input.checked ? '1' : '0');
        } catch (error) {
          // private mode or storage blocked: the toggle still works for this visit
        }
        document.querySelectorAll('[data-size-chart-zoom]').forEach((other) => {
          other.checked = input.checked;
        });
      });
    });
  };

  init();
  initZoom();

  // the size chart lives in the quantity block, which is re-rendered on variant change
  new MutationObserver(() => {
    init();
    initZoom();
  }).observe(document.body, { childList: true, subtree: true });
})();
